import axios from './axios'

export default class StoryService{
    static async list(query={}){
        return await axios.get("/story/list",{
            params:query
        })

    }

    static async detail(slug){
        return await axios.get("/story/details/"+slug)
    }
}
